import { useCountries } from './useCountries';
import { useProfile } from './useProfile';

/**
 * The `iso2` of the signed-in person's own country (from their account profile), or `undefined`
 * when it is not set or the lists have not loaded. Feeds `PhoneField`'s `defaultCountryIso2`
 * (FR-184: "the default country is the user's country when known").
 */
export function useProfileCountryIso2(): string | undefined {
  const { data: profile } = useProfile();
  const { data: countries = [] } = useCountries();
  if (profile?.countryId == null) return undefined;
  return countries.find((country) => country.id === profile.countryId)?.iso2;
}
